import { FlowRouteCategory } from '@eneco/flows/types';

import { OfferStep } from './steps/OfferStep_C';
import { shouldSkipWhenOnlyGeothermalHeating, shouldSkipWhenOnlyWarmth } from '../../skippingRules';
import { TestConfigVariant } from '../../types/experiment';

export const exp_n_575_C: TestConfigVariant = {
  testKey: 'exp-n-575-product-card-discount-engine',
  variant: 'C',
  routes: [
    {
      id: 'OFFER',
      path: '/productkeuze/looptijd/',
      category: FlowRouteCategory.Overview,
      component: OfferStep,
      skippingRules: [shouldSkipWhenOnlyWarmth, shouldSkipWhenOnlyGeothermalHeating],
    },
  ],
};
